import { render, staticRenderFns } from "./ReportProvinzen.vue?vue&type=template&id=8bbd73fe"
import script from "./ReportProvinzen.vue?vue&type=script&lang=js"
export * from "./ReportProvinzen.vue?vue&type=script&lang=js"
import style0 from "./ReportProvinzen.vue?vue&type=style&index=0&id=8bbd73fe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports